<mat-card class="cur-card">
    <mat-card-header>
        <mat-card-title>基本情報</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="tw-flex tw-flex-row tw-box-border tw-justify-start tw-items-center tw-content-center"
            style="overflow: auto;">
            <mat-form-field appearance="outline" class="input-form-basic-info">
                <mat-label>口座入金予定日</mat-label>
                <input readonly="true" [value]="basicInfo.kouzaReceivemoneyyoteiDate | dateString" matInput
                    autocomplete="off" />
            </mat-form-field>
            <mat-form-field appearance="outline" class="input-form-basic-info-other2">
                <mat-label>入金口座</mat-label>
                <input readonly="true" [value]="basicInfo.rcvmnyKouza" matInput autocomplete="off" />
            </mat-form-field>
            <mat-form-field appearance="outline" class="input-form-basic-info">
                <mat-label>入金形態</mat-label>
                <input readonly="true" [value]="basicInfo.rcvmnyKeitai" matInput autocomplete="off" />
            </mat-form-field>
            <mat-form-field appearance="outline" class="input-form-basic-info-other">
                <mat-label>入金取扱機関</mat-label>
                <input readonly="true" [value]="basicInfo.rcvmnyHandlinginstitution" matInput autocomplete="off" />
            </mat-form-field>
            <mat-form-field appearance="outline" class="input-form-basic-info-other">
                <mat-label>口座入金機関</mat-label>
                <input readonly="true" [value]="basicInfo.kouzaRcvmnyFclt" matInput autocomplete="off" />
            </mat-form-field>
            <mat-form-field appearance="outline" class="input-form-basic-info">
                <mat-label>承認年月日</mat-label>
                <input readonly="true" [value]="basicInfo.apprvYearmonthdate | dateString" matInput autocomplete="off" />
            </mat-form-field>
            <mat-form-field appearance="outline" class="input-form-basic-info">
                <mat-label>突合ステータス</mat-label>
                <input readonly="true" [value]="basicInfo.reconciliationSts" matInput autocomplete="off" />
            </mat-form-field>
            <mat-form-field appearance="outline" class="input-form-basic-info">
                <mat-label>振替日/売上報告日</mat-label>
                <input readonly="true" [value]="basicInfo.transferdateSalesreportdate | dateString" matInput
                    autocomplete="off" />
            </mat-form-field>
        </div>
    </mat-card-content>
</mat-card>